import InterprationChart from './components/InterpretationChart';
import ResultatEvaluation from './components/ResultatEvaluation';
import { IInformationDiagnostic } from './type';

export { InterprationChart, ResultatEvaluation, type IInformationDiagnostic };
